module.exports = __webpack_public_path__ + "build/img/winter1.ec474fb3.png";